import { AppStepIndicatorItemViewModel } from './app-step-indicator-item.viewmodel';
import { StepIndicatorViewModel } from './step-indicator.viewmodel';
import { StepModel } from './step-model.viewmodel';

export class AppStepIndicatorViewModel extends StepIndicatorViewModel<
    string,
    AppStepIndicatorItemViewModel
> {
    constructor(
        baseRoute: string[],
        steps: StepModel[],
        selectedStepId: string
    ) {
        // By default we assume that the first step is selected
        let selectedItemId = selectedStepId;

        const items = steps.map(
            (step) => new AppStepIndicatorItemViewModel(step)
        );
        const selectedItem = items.find(
            (step) => step.stepId === selectedStepId
        );
        if (
            selectedItem &&
            selectedItem.isVisible &&
            selectedItem.isDisabled === false
        ) {
            // If the to be selected step is visible and enabled, then we use it as the selected step
            selectedItemId = selectedItem.stepId;
        }

        super(baseRoute, items, selectedItemId);
    }
}
